import { Rental } from '../../../RentalsPopover'

export type RentalIdProps = {
	rental: Rental,
}
export default function RentalId( { rental }: RentalIdProps ) {
	return (
		<span>
			{rental.rentalId}
		</span>
	)
}
